/*
 * @prop --component-breadcrumb-color-text: Color of breadcump text
*/

// BREADCRUMBS       ---- from placeholders, but not loaded while building component
$breadcrumb-font-size: 14px;
$breadcrumb-line-height: 20px;
$breadcrumb-font-weight: $font-weight-normal;

$breadcrumb-font-size-medium: $breadcrumb-font-size;
$breadcrumb-line-height-medium: $breadcrumb-line-height;

$breadcrumb-font-size-desktop: $breadcrumb-font-size-medium;
$breadcrumb-line-height-desktop: $breadcrumb-line-height-medium;

%breadcrumb {
  font-family: var(--skin-font-family-primary, $font-family-sans-serif);
  font-weight: $breadcrumb-font-weight;
  font-size: $breadcrumb-font-size;
  line-height: $breadcrumb-line-height;

  @include breakpoint($medium) {
    font-size: $breadcrumb-font-size-medium;
    line-height: $breadcrumb-line-height-medium;
  }

  @include breakpoint($desktop) {
    font-size: $breadcrumb-font-size-desktop;
    line-height: $breadcrumb-line-height-desktop;
  }
}

/* breadcrumbs */
$spacing: 6px;

ui-cms-breadcrumb {
  display: block;
  overflow: auto;

  nav {
    @extend %breadcrumb;

    @include breakpoint($xsmall) {
      float: left;
    }

    @include breakpoint($desktop) {
      width: 66.6667%;
      float: left;
    }

    ol {
      @include reset-ul();

      font-family: var(--skin-font-family-primary, $font-family-sans-serif);
      margin-left: -5px;
      padding-bottom: 8px;
      padding-top: 4px;

      /*
       * This is the behavior for devices which CAN hover:
       * The breadcrumb-container isn't scrollable.
       * [1] Every item gets a max width of container divided thorugh amount of items:
       * [2] If the item is small enough, it's shown completely and other items get more space.
       * [3] If it's too big, it's truncated, but when hovered, it's shown in full size.
       */

      @media (hover: hover) {
        display: grid; // [1+2]
        grid-auto-flow: column; // [1+2]
        justify-content: start; // [1+2]

        li {
          overflow: hidden; // [3]
          text-overflow: ellipsis; // [3]
          white-space: nowrap; // [3]
        }

        li:hover {
          overflow: visible; // [3]
        }
      }

      /*
       * This is the behavior for devices which CANNOT hover:
       * [1] The whole breadcrumb has a maximum size and is scrollable.
       * [2] Every item is shown in it's full length in a single line.
       * [3] The items are truncated if they would exceed the container size, to prevent illusion of completeness.
       * (More about Illusion of Completeness: https://www.nngroup.com/articles/illusion-of-completeness/)
       * To improve usability, initial scroll position is set to end of breadcrumb via JS on componentDidLoad()
       */

      @media (hover: none) {
        display: flex;
        overflow-x: scroll; // [1]
        white-space: nowrap; // [1]
        scrollbar-width: none; // remove scrollbar in FF
        &::-webkit-scrollbar {
          display: none; // remove scrollbar in Safari and Chrome
        }

        li {
          flex-shrink: 0; // [2]
          white-space: nowrap; // [2]
          max-width: calc(100vw - 30px - 50px); // [3]
          text-overflow: ellipsis; // [3]
          overflow: hidden; // [3]
        }
      }

      li {
        @include reset-li();

        display: inline-block;
        position: relative;
        padding: 0 3px 0 0;
        color: $ui-grey;

        &::before {
          @include getIcon('\e638');

          font-size: 12px;
          padding-right: $spacing;
          padding-left: 4px;
          color: $ui-blue;

          [class*='container--bg'] & {
            color: $ui-white;
          }
        }

        &:first-child {
          &::before {
            content: none;
          }

          a,
          > span {
            padding-left: $spacing;
          }
        }

        &:last-child {
          color: var(--component-breadcrumb-color-text, var(--skin-color-accent, $ui-green));
        }

        span {
          line-height: 26px;
        }

        a {
          color: $ui-blue;

          &:hover {
            color: $ui-blue-minus-1;
          }

          [class*='container--bg'] & {
            color: $ui-white;

            &:hover {
              color: $ui-blue-minus-3;
            }
          }
        }
      }
    }
  }
}
